<template>
  <div class="ggtf-container">
    <!-- 头部 -->
    <div class="ggtf-header">
      <h1 class="ggtf-title">{{ $t('_bq._bqtz') }}</h1>
      <div class="ggtf-tabs">
        <button :class="['ggtf-tab', { 'ggtf-active': activeTab === 'list' }]" @click="activeTab = 'list'">{{ $t('_ggtf._splb') }}</button>
        <button :class="['ggtf-tab', { 'ggtf-active': activeTab === 'my' }]" @click="activeTab = 'my'">{{ $t('_ggtf._wcyd') }}</button>
      </div>
    </div>

    <!-- 视频列表 -->
    <video-invest-list v-if="activeTab === 'list'"></video-invest-list>

    <!-- 我参与的 -->
    <video-my-invest-list v-else></video-my-invest-list>
  </div>
</template>

<script>
import VideoInvestList from '@/components/adv/VideoInvestList.vue'
import VideoMyInvestList from '@/components/adv/VideoMyInvestList.vue'
export default {
  name: 'AdDelivery',
  components: { VideoInvestList, VideoMyInvestList },
  data() {
    return {
      activeTab: 'list'
    }
  },
  methods: {}
}
</script>

<style scoped>
@import url('../../static/css_adv/1.css');
</style>
